export default __webpack_public_path__ + "static/media/fluent-learning.758683f1.svg";